import {createFileRoute} from '@tanstack/react-router'

import QuizV2Flow from '../eventQuizV2/QuizV2Flow.tsx'
import {eventQuizOn, useSports} from '../sports/registry.ts'

/**
 * The onboarding quiz v2 (docs/onboarding-v2): regular or one-off, a report, then setup and sign-up.
 * Alongside /event-quiz/ (the "describe your event" flow), behind the same event_quiz_enabled
 * switch: while it is off the server 404s the endpoints, so the page sends the organizer to signup.
 */
export const Route = createFileRoute('/event-quiz-v2')({
    component: EventQuizV2Page,
    head: () => ({meta: [{title: 'Get your events running themselves | ScorePal'}, {name: 'robots', content: 'noindex'}]}),
})

function EventQuizV2Page() {
    const {data: registry} = useSports()

    if (!eventQuizOn(registry)) {
        return (
            <div className="grid min-h-screen place-items-center bg-[#f5f9ff] px-4 text-center">
                <div>
                    <h1 className="text-2xl font-extrabold text-[#0a1b60]">Get your events running themselves</h1>
                    <a href="/signup/player/" className="mt-4 inline-block rounded-full bg-[#0969f4] px-6 py-3 font-semibold text-white">Get started free</a>
                </div>
            </div>
        )
    }

    return <QuizV2Flow />
}
